import {PALETTE_IDS} from '#core/application/modules/ids.js';

import {COLOR, FONT} from '../theme.js';

export function getVirtualsConfig() {
    return {
        palette: {
            [PALETTE_IDS.VIRTUALS]: {
                VIRTUALS_EVENT_NAME_TEXT: {
                    color: COLOR.BRAND.FOREGROUND5,
                    fontSize: FONT.SIZE_MEDIUM,
                    textTransform: 'capitalize',
                },
                VIRTUALS_EVENT_SELECTOR_BG: COLOR.BRAND.BACKGROUND4,

                VIRTUALS_STREAM_CONTAINER_BG: COLOR.RESERVED.BLACK,

                VIRTUALS_NEXT_EVENT_COUNTDOWN_TEXT: COLOR.BRAND.ACCENT2,
                VIRTUALS_NEXT_EVENT_COUNTDOWN_BG: COLOR.BRAND.BACKGROUND5,
            },
        },
    };
}
